// Heuristic: rows coming from Status Changes / selection-level tables often carry
// selection fields but omit the full `productSelections` array (or include an empty placeholder).
// In those cases, the detail pane should hydrate selections automatically.
export const rowLooksLikeSelectionContext = (row) => {
  if (!row) return false;
  const id = row?.id != null ? String(row.id) : '';
  if (id.startsWith('status-change-')) return true;
  return Boolean(
    row?.changeId ||
      row?.previousStatus ||
      row?.newStatus ||
      row?.serviceItemName ||
      row?.vendorCode ||
      row?.vendorName ||
      row?.referenceId
  );
};

